import getDistance from './getDistance'

/**
 * Calculates the ratio of 2 segments defined by pairs of points.
 * Returns ratio of second segment to first.
 */
export default function getSegmentsRatio(ab, cd) {
  return getDistance(...cd) / getDistance(...ab)
}
